import "./HowItWorksIntro.scss";

export default function HowItWorksIntro() {
  return (
    <div className="HowItWorksIntro">
      Статус, который возможно узнать с помощью чат-бота “Хочу найти”
    </div>
  );
}
